export default __webpack_public_path__ + "static/media/instagram_icon-white.2f7eb39b.svg";